import React, { CSSProperties } from 'react';

interface GlobeProps {
  fill?: string;
  secondaryfill?: string;
  width?: string;
  height?: string;
  style?: CSSProperties;
  className?: string;
}

const Globe: React.FC<GlobeProps> = ({ fill = 'currentColor', secondaryfill, width = '100%', height = '100%', style, className }) => {
  return (
    <svg className={className} height={height} width={width} viewBox="0 0 1060 1060" xmlns="http://www.w3.org/2000/svg" style={style}>
      <g fill={fill}>
        <defs />
        <circle cx="530" cy="530" fill="none" r="313" stroke={fill} strokeLinecap="round" strokeLinejoin="round" strokeWidth="50px" />
        <path d="M454.43 232.22s-49.7 73.85-49.7 297.78 49.7 297.78 49.7 297.78" fill="none" stroke={fill} strokeLinecap="round" strokeLinejoin="round" strokeWidth="50px" />
        <path d="M599.07 232.22s49.7 73.85 49.7 297.78c0 223.93-49.7 297.78-49.7 297.78" fill="none" stroke={fill} strokeLinecap="round" strokeLinejoin="round" strokeWidth="50px" />
        <path d="M824.53 457.68s-73.85-49.7-297.78-49.7-297.78 49.7-297.78 49.7" fill="none" stroke={fill} strokeLinecap="round" strokeLinejoin="round" strokeWidth="50px" />
        <path d="M824.53 602.32s-73.85 49.7-297.78 49.7-297.78-49.7-297.78-49.7" fill="none" stroke={fill} strokeLinecap="round" strokeLinejoin="round" strokeWidth="50px" />
      </g>
    </svg>
  );
};

export default Globe;
